import React, {useState} from 'react';
import Input from '../../../components/common/input/Input';
import Button from '../../../components/common/button/Button';
import {useNavigate} from 'react-router-dom';
import codevisionLogo from '../../../assets/covi_logo_white.png';
import styles from './FindPasswordPage.module.css';
import {findPasswordAPI} from '../../../services/auth';
import {useAlert} from "../../../components/common/error/AlertContext";

//비밀번호 찾기 페이지
const FindPasswordPage: React.FC = () => {
    const navigate = useNavigate();
    const {showAlert} = useAlert();
    const [formData, setFormData] = useState({
        email: '',
        businessNumber: ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            //비밀번호 초기화 API, 메일로 임시 비밀번호 발급
            await findPasswordAPI(formData.email, formData.businessNumber);
            showAlert("비밀번호가 초기화되었습니다. 이메일을 확인해주세요.", "info");
            //로그인 페이지로 이동
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <div className={styles.pageContainer}>
                <img src={codevisionLogo} alt="Codevision Logo" className={styles.logo}/>
                <div className={styles.formContainer}>
                    <h1 className={styles.title}>비밀번호 찾기</h1>
                    {/*로그인 페이지로 이동*/}
                    <a href="/login" className={styles.loginLink}>
                        로그인 화면으로
                    </a>

                    <form onSubmit={handleSubmit} className={styles.form}>
                        {/*이메일 입력*/}
                        <Input
                            label="Email"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                        {/*사업자등록번호 입력*/}
                        <Input
                            label="사업자등록번호"
                            name="businessNumber"
                            value={formData.businessNumber}
                            onChange={handleChange}
                            fullWidth
                            required
                        />
                        {/*비밀번호 초기화 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            fullWidth
                        >
                            비밀번호 초기화
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FindPasswordPage;